import {
    ADMINGETLANGUAGELIST_SUCCESS,
    ADMINGETLANGUAGELIST_FAILED,
    RESET_ADMINGETLANGUAGELIST,
    LOADING_ADMINGETLANGUAGELIST,
    NETWORK_ERROR_ADMINGETLANGUAGELIST
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetLanguageList = () => {
    return { type: RESET_ADMINGETLANGUAGELIST };
};

const getLanguageListAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETLANGUAGELIST });
    await adminServices
        .post("getLanguageList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetLanguageListsuccess(res.data));
                    break;
                default:
                    dispatch(adminGetLanguageListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETLANGUAGELIST,
                payload: err
            });
        });
};


function adminGetLanguageListsuccess(data) {
    return {
        type: ADMINGETLANGUAGELIST_SUCCESS,
        payload: data
    };
}
function adminGetLanguageListFailed(data) {
    return {
        type: ADMINGETLANGUAGELIST_FAILED,
        payload: data
    };
}

export { getLanguageListAdmin, resetAdminGetLanguageList }